import {
  nav,
  getHeight,
  headerNav,
  setSaveFunction
} from './action'

const dispatchNav = (dispatch: Function) => (data: any) => {
  dispatch(nav(data));
};
const dispatchNavHeight = (dispatch: Function) => (height: any) => {
  dispatch(getHeight(height));
};

const dispatchHeaderNav = (dispatch: Function) => (nav: any) => {
  dispatch(headerNav(nav));
};
const dispatchSaveFunction = (dispatch: Function) => (data: any) => {
  dispatch(setSaveFunction(data));
};

const operations = {
  dispatchNav,
  dispatchNavHeight,
  dispatchHeaderNav,
  dispatchSaveFunction
}

export default operations